/* eslint-disable quotes */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SUPPORT_ID, SUPPORT_NAME } from "../Helpers/common";
import {
  setAttendeeData,
  setShowPhoneSupport,
  setSidebarActiveData,
} from "../redux/chatSlice";
import { getData, updateDataInDB } from "../util/indexedDB";
import { useChatState } from "../../hooks/useChatState";

const PhoneSupportItem = () => {
  const [isUnread, setIsUnread] = useState(false);
  const dispatch = useDispatch();
  const { authSessionUser } = useSelector(
    (state) => state.authUserDetail || {},
  );

  const { allAttendeeList } = useSelector((state) => state.call || {});

  const { showPhoneSupport, chatRoom } = useChatState();

  // ✅ Mark as read only if needed
  const markPhoneSupportAsRead = useCallback(async () => {
    const chatMessagesData = await getData("phone-support");
    const list = chatMessagesData?.list || [];

    const hasUnread = list.some((msg) => msg.unread === true);
    if (!hasUnread) return;

    const updatedList = list.map((msg) => ({
      ...msg,
      unread: false,
    }));

    await updateDataInDB({
      id: "phone-support",
      list: updatedList,
    });
  }, []);

  useEffect(() => {
    const fetchChat = async () => {
      // if already inside phone-support, no unread

      if (chatRoom === "phone-support") {
        setIsUnread(false);
        await markPhoneSupportAsRead();
        return;
      }

      const chatMessagesData = await getData("phone-support");

      const hasUnread = chatMessagesData?.list?.some(
        (msg) => msg.unread === true,
      );

      setIsUnread(Boolean(hasUnread));
    };

    fetchChat();

    const handler = () => fetchChat();
    window.addEventListener("INDEXED_DB_UPDATED", handler);

    return () => {
      window.removeEventListener("INDEXED_DB_UPDATED", handler);
    };
  }, [chatRoom]);

  const group = {
    groupId: SUPPORT_ID,
    adminId: allAttendeeList?.find((item) => item.role === "Manager")?.user_id,
    groupName: SUPPORT_NAME,
    description: "",
    timestamp: Date.now(),
    attendeeId: allAttendeeList?.map((item) => item.user_id)?.slice(0, 100),
    hostId: allAttendeeList
      ?.filter((item) => item.role === "Manager")
      ?.map((item) => item.user_id),

    lastactivity: Date.now(),
    company_id: allAttendeeList[0]?.company_id,
    group_active: true,
    receiverID: SUPPORT_ID,
    logged_user_id: authSessionUser?.user_id,
    user_id: SUPPORT_ID,
    count: 0,
    notification_sound: true,
    group_mute: false,
    type: "group",
    username: allAttendeeList
      ?.map((item) => item.name)
      .join(",")
      ?.slice(0, 100),
  };

  const handleSelectSupportGroup = () => {
    dispatch(setShowPhoneSupport(true));
    dispatch(setSidebarActiveData(group.groupId));

    dispatch(
      setAttendeeData({ ...group, type: "group", username: group.username }),
    );
  };

  return (
    <>
      <div
        className={`message-list-head d-flex content--h-space-between align-items-center cursor-pointer ${
          showPhoneSupport ? "selected" : ""
        }`}
        onClick={handleSelectSupportGroup}
      >
        <div className="d-flex align-items-center gap--4">
          <div className={`icon_container expend-chevron `}>
            {" "}
            <svg width="9.13" height="9.13" viewBox="5 9 14 8">
              <path fill="#b8c0c9" d="m11.998 17 7-8h-14z"></path>
            </svg>
          </div>
          <span className="text-green">PHONE SUPPORT</span>
          {isUnread && <span className="unread-dot" />}
        </div>
        <div className="icon_container">
          <svg width="16.826" height="16.867" viewBox="2 2.29 20 19.41">
            <path
              fill="#b8c0c9"
              d="M18 7c0-1.103-.897-2-2-2H6.414L3.707 2.293 2.293 3.707l18 18 1.414-1.414L18 16.586v-2.919L22 17V7l-4 3.333V7zm-2 7.586L8.414 7H16v7.586zM4 19h10.879l-2-2H4V8.121L2.145 6.265A1.977 1.977 0 0 0 2 7v10c0 1.103.897 2 2 2z"
            ></path>
          </svg>
        </div>
      </div>
    </>
  );
};

export default PhoneSupportItem;
